import "../App.css";
import { useAuth } from "../contexts/AuthContext";
import { Container, Row, Col, Image, Nav, Button } from "react-bootstrap";
// 1. Swap 'Link' for 'NavLink'
import { NavLink } from "react-router-dom";

function LoggedInHeader() {
  const { currentUser, logout } = useAuth();

  return (
    <Container className="header-purple" fluid>
      <Row>
        <Col xs={12} md={4} className="text-center text-md-start">
          <a href="/">
            <Image
              src="/logged-in-logo.png"
              alt="CTGWeb 2.0 Logo"
              style={{ height: "50px", marginBlock: "2rem" }}
            />
          </a>
        </Col>
        <Col className="d-flex flex-column">
          <Row>
            <Col>
              <Nav
                variant="underline"
                className="justify-content-center justify-content-md-end"
              >
                <Nav.Item>
                  <Nav.Link as={NavLink} className="navbar-link" to="/">
                    Home
                  </Nav.Link>
                </Nav.Item>
                { currentUser.profile?.ctg_course_paid === true &&
                  <Nav.Item>
                    <Nav.Link as={NavLink} className="navbar-link" to="/resources">
                      Resources
                    </Nav.Link>
                  </Nav.Item>
                }
                { currentUser.user.dashboard_access === true &&
                  <Nav.Item>
                    <Nav.Link as={NavLink} className="navbar-link" to="/admin_dashboard">
                      Admin Dashboard
                    </Nav.Link>
                  </Nav.Item>
                }
                <Nav.Item>
                  <Nav.Link as={NavLink} className="navbar-link" to="/contact">
                    Contact
                  </Nav.Link>
                </Nav.Item>
                { currentUser.profile?.ctg_course_paid === true &&
                  <Nav.Item>
                    <Nav.Link as={NavLink} className="navbar-link" to="/profile/edit">
                      Account
                    </Nav.Link>
                  </Nav.Item>
                }
                <Button className="log-button ms-2" onClick={logout}>
                  Logout
                </Button>
              </Nav>
            </Col>
          </Row>
          <Row className="pt-4">
            <Col>
              <p className="user-email text-center text-md-end">
                Signed in as: {currentUser?.user?.email}
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default LoggedInHeader;
